/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CvDto } from '../models/cv-dto';
import { CvFilterDto } from '../models/cv-filter-dto';
import { SearchDto } from '../models/search-dto';

@Injectable({
  providedIn: 'root',
})
export class CvRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createConsultantCv
   */
  static readonly CreateConsultantCvPath = '/api/v1/cv';

  /**
   * Create a new consultant cv (from origin cv) for a specified user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createConsultantCv()` instead.
   *
   * This method doesn't expect any request body.
   */
  createConsultantCv$Response(params: {
                                userID?: number;
                                language: 'GERMAN' | 'ENGLISH';
                                name: string;
                              },
                              context?: HttpContext

  ): Observable<StrictHttpResponse<CvDto>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.CreateConsultantCvPath, 'put');
    if (params) {
      rb.query('userID', params.userID, {});
      rb.query('language', params.language, {});
      rb.query('name', params.name, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CvDto>;
      })
    );
  }

  /**
   * Create a new consultant cv (from origin cv) for a specified user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createConsultantCv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createConsultantCv(params: {
                       userID?: number;
                       language: 'GERMAN' | 'ENGLISH';
                       name: string;
                     },
                     context?: HttpContext

  ): Observable<CvDto> {

    return this.createConsultantCv$Response(params,context).pipe(
      map((r: StrictHttpResponse<CvDto>) => r.body as CvDto)
    );
  }

  /**
   * Path part for operation parseCv
   */
  static readonly ParseCvPath = '/api/v1/cv';

  /**
   * Upload / parse an CV.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parseCv()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  parseCv$Response(params?: {
                     body?: {
                       'file': Blob;
                     }
                   },
                   context?: HttpContext

  ): Observable<StrictHttpResponse<CvDto>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.ParseCvPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CvDto>;
      })
    );
  }

  /**
   * Upload / parse an CV.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `parseCv$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  parseCv(params?: {
            body?: {
              'file': Blob;
            }
          },
          context?: HttpContext

  ): Observable<CvDto> {

    return this.parseCv$Response(params,context).pipe(
      map((r: StrictHttpResponse<CvDto>) => r.body as CvDto)
    );
  }

  /**
   * Path part for operation getCvById
   */
  static readonly GetCvByIdPath = '/api/v1/cv/{id}';

  /**
   * Provides a cv by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCvById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvById$Response(params: {
                       id: number;
                     },
                     context?: HttpContext

  ): Observable<StrictHttpResponse<CvDto>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.GetCvByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CvDto>;
      })
    );
  }

  /**
   * Provides a cv by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCvById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvById(params: {
              id: number;
            },
            context?: HttpContext

  ): Observable<CvDto> {

    return this.getCvById$Response(params,context).pipe(
      map((r: StrictHttpResponse<CvDto>) => r.body as CvDto)
    );
  }

  /**
   * Path part for operation versionConsultantCv
   */
  static readonly VersionConsultantCvPath = '/api/v1/cv/{id}';

  /**
   * Create a new version of an consultant cv.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionConsultantCv()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionConsultantCv$Response(params: {
                                 id: number;
                               },
                               context?: HttpContext

  ): Observable<StrictHttpResponse<CvDto>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.VersionConsultantCvPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CvDto>;
      })
    );
  }

  /**
   * Create a new version of an consultant cv.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionConsultantCv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionConsultantCv(params: {
                        id: number;
                      },
                      context?: HttpContext

  ): Observable<CvDto> {

    return this.versionConsultantCv$Response(params,context).pipe(
      map((r: StrictHttpResponse<CvDto>) => r.body as CvDto)
    );
  }

  /**
   * Path part for operation deleteCv
   */
  static readonly DeleteCvPath = '/api/v1/cv/{id}';

  /**
   * Removes Cv from the list based on the given cv id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCv()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCv$Response(params: {
                      id: number;
                    },
                    context?: HttpContext

  ): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.DeleteCvPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removes Cv from the list based on the given cv id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCv(params: {
             id: number;
           },
           context?: HttpContext

  ): Observable<void> {

    return this.deleteCv$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getCvsBySearchTerms
   */
  static readonly GetCvsBySearchTermsPath = '/api/v1/cv/list/search';

  /**
   * Provides a list of SearchDto holding filtered origin Cvs based on the search terms.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCvsBySearchTerms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvsBySearchTerms$Response(params?: {
                                 pageNumber?: number;
                                 pageSize?: number;
                                 nameList?: Array<string>;
                                 lastnameList?: Array<string>;
                                 userroleList?: Array<string>;
                                 branchList?: Array<string>;
                                 languageList?: Array<string>;
                                 certificateList?: Array<string>;
                                 itcompetenceList?: Array<string>;
                                 professionalcompList?: Array<string>;
                                 customerList?: Array<string>;
                                 projectTypeList?: Array<string>;
                                 projectApproachList?: Array<string>;
                                 projectroleList?: Array<string>;
                                 technologyList?: Array<string>;
                               },
                               context?: HttpContext

  ): Observable<StrictHttpResponse<Array<SearchDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.GetCvsBySearchTermsPath, 'get');
    if (params) {
      rb.query('pageNumber', params.pageNumber, {});
      rb.query('pageSize', params.pageSize, {});
      rb.query('nameList', params.nameList, {});
      rb.query('lastnameList', params.lastnameList, {});
      rb.query('userroleList', params.userroleList, {});
      rb.query('branchList', params.branchList, {});
      rb.query('languageList', params.languageList, {});
      rb.query('certificateList', params.certificateList, {});
      rb.query('itcompetenceList', params.itcompetenceList, {});
      rb.query('professionalcompList', params.professionalcompList, {});
      rb.query('customerList', params.customerList, {});
      rb.query('projectTypeList', params.projectTypeList, {});
      rb.query('projectApproachList', params.projectApproachList, {});
      rb.query('projectroleList', params.projectroleList, {});
      rb.query('technologyList', params.technologyList, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SearchDto>>;
      })
    );
  }

  /**
   * Provides a list of SearchDto holding filtered origin Cvs based on the search terms.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCvsBySearchTerms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvsBySearchTerms(params?: {
                        pageNumber?: number;
                        pageSize?: number;
                        nameList?: Array<string>;
                        lastnameList?: Array<string>;
                        userroleList?: Array<string>;
                        branchList?: Array<string>;
                        languageList?: Array<string>;
                        certificateList?: Array<string>;
                        itcompetenceList?: Array<string>;
                        professionalcompList?: Array<string>;
                        customerList?: Array<string>;
                        projectTypeList?: Array<string>;
                        projectApproachList?: Array<string>;
                        projectroleList?: Array<string>;
                        technologyList?: Array<string>;
                      },
                      context?: HttpContext

  ): Observable<Array<SearchDto>> {

    return this.getCvsBySearchTerms$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<SearchDto>>) => r.body as Array<SearchDto>)
    );
  }

  /**
   * Path part for operation getCvsByFilters
   */
  static readonly GetCvsByFiltersPath = '/api/v1/cv/list/search';

  /**
   * Provides a list of SearchDto holding filtered origin Cvs based on the search terms.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCvsByFilters()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getCvsByFilters$Response(params: {
                             pageNumber?: number;
                             pageSize?: number;
                             body: Array<CvFilterDto>
                           },
                           context?: HttpContext

  ): Observable<StrictHttpResponse<Array<SearchDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.GetCvsByFiltersPath, 'put');
    if (params) {
      rb.query('pageNumber', params.pageNumber, {});
      rb.query('pageSize', params.pageSize, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SearchDto>>;
      })
    );
  }

  /**
   * Provides a list of SearchDto holding filtered origin Cvs based on the search terms.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCvsByFilters$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getCvsByFilters(params: {
                    pageNumber?: number;
                    pageSize?: number;
                    body: Array<CvFilterDto>
                  },
                  context?: HttpContext

  ): Observable<Array<SearchDto>> {

    return this.getCvsByFilters$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<SearchDto>>) => r.body as Array<SearchDto>)
    );
  }

  /**
   * Path part for operation reindex
   */
  static readonly ReindexPath = '/api/v1/cv/index';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reindex()` instead.
   *
   * This method doesn't expect any request body.
   */
  reindex$Response(params?: {
                   },
                   context?: HttpContext

  ): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.ReindexPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reindex$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reindex(params?: {
          },
          context?: HttpContext

  ): Observable<void> {

    return this.reindex$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation exportCv
   */
  static readonly ExportCvPath = '/api/v1/cv/{id}/export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportCv()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportCv$Response(params: {
                      id: number;
                    },
                    context?: HttpContext

  ): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.ExportCvPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportCv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportCv(params: {
             id: number;
           },
           context?: HttpContext

  ): Observable<any> {

    return this.exportCv$Response(params,context).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation getResourceFileByHash
   */
  static readonly GetResourceFileByHashPath = '/api/v1/cv/tmp/{fileName}';

  /**
   * Retrieves temporary saved cv files.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getResourceFileByHash()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResourceFileByHash$Response(params: {
                                   fileName: string;
                                 },
                                 context?: HttpContext

  ): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.GetResourceFileByHashPath, 'get');
    if (params) {
      rb.path('fileName', params.fileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Retrieves temporary saved cv files.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getResourceFileByHash$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResourceFileByHash(params: {
                          fileName: string;
                        },
                        context?: HttpContext

  ): Observable<Blob> {

    return this.getResourceFileByHash$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation getCvsBySearchText
   */
  static readonly GetCvsBySearchTextPath = '/api/v1/cv/search';

  /**
   * Provides a list of SearchDto holding filtered origin Cvs based on the free search texts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCvsBySearchText()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvsBySearchText$Response(params?: {
                                pageNumber?: number;
                                pageSize?: number;
                                text?: string;
                              },
                              context?: HttpContext

  ): Observable<StrictHttpResponse<Array<SearchDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.GetCvsBySearchTextPath, 'get');
    if (params) {
      rb.query('pageNumber', params.pageNumber, {});
      rb.query('pageSize', params.pageSize, {});
      rb.query('text', params.text, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SearchDto>>;
      })
    );
  }

  /**
   * Provides a list of SearchDto holding filtered origin Cvs based on the free search texts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCvsBySearchText$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvsBySearchText(params?: {
                       pageNumber?: number;
                       pageSize?: number;
                       text?: string;
                     },
                     context?: HttpContext

  ): Observable<Array<SearchDto>> {

    return this.getCvsBySearchText$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<SearchDto>>) => r.body as Array<SearchDto>)
    );
  }

  /**
   * Path part for operation getCvsByLanguage
   */
  static readonly GetCvsByLanguagePath = '/api/v1/cv/origin/{language}';

  /**
   * Provides the CV for the logged in user and given language.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCvsByLanguage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvsByLanguage$Response(params: {
                              language: 'GERMAN' | 'ENGLISH';
                            },
                            context?: HttpContext

  ): Observable<StrictHttpResponse<CvDto>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.GetCvsByLanguagePath, 'get');
    if (params) {
      rb.path('language', params.language, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CvDto>;
      })
    );
  }

  /**
   * Provides the CV for the logged in user and given language.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCvsByLanguage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvsByLanguage(params: {
                     language: 'GERMAN' | 'ENGLISH';
                   },
                   context?: HttpContext

  ): Observable<CvDto> {

    return this.getCvsByLanguage$Response(params,context).pipe(
      map((r: StrictHttpResponse<CvDto>) => r.body as CvDto)
    );
  }

  /**
   * Path part for operation getCvsByType
   */
  static readonly GetCvsByTypePath = '/api/v1/cv/list/{cvType}';

  /**
   * Provides a list of CVs for the logged in user and given CV type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCvsByType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvsByType$Response(params: {
                          cvType: 'ORIGIN_CV' | 'CONSULTANT_CV';
                        },
                        context?: HttpContext

  ): Observable<StrictHttpResponse<Array<CvDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.GetCvsByTypePath, 'get');
    if (params) {
      rb.path('cvType', params.cvType, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CvDto>>;
      })
    );
  }

  /**
   * Provides a list of CVs for the logged in user and given CV type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCvsByType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvsByType(params: {
                 cvType: 'ORIGIN_CV' | 'CONSULTANT_CV';
               },
               context?: HttpContext

  ): Observable<Array<CvDto>> {

    return this.getCvsByType$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<CvDto>>) => r.body as Array<CvDto>)
    );
  }

  /**
   * Path part for operation getCvsByUserIdAndCvType
   */
  static readonly GetCvsByUserIdAndCvTypePath = '/api/v1/cv/list/user/{userId}/{cvType}';

  /**
   * Provides a list of CVs based on the given user id and Cv type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCvsByUserIdAndCvType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvsByUserIdAndCvType$Response(params: {
                                     userId: number;
                                     cvType: 'ORIGIN_CV' | 'CONSULTANT_CV';
                                   },
                                   context?: HttpContext

  ): Observable<StrictHttpResponse<CvDto>> {

    const rb = new RequestBuilder(this.rootUrl, CvRestControllerService.GetCvsByUserIdAndCvTypePath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('cvType', params.cvType, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CvDto>;
      })
    );
  }

  /**
   * Provides a list of CVs based on the given user id and Cv type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCvsByUserIdAndCvType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvsByUserIdAndCvType(params: {
                            userId: number;
                            cvType: 'ORIGIN_CV' | 'CONSULTANT_CV';
                          },
                          context?: HttpContext

  ): Observable<CvDto> {

    return this.getCvsByUserIdAndCvType$Response(params,context).pipe(
      map((r: StrictHttpResponse<CvDto>) => r.body as CvDto)
    );
  }

}
